/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserService } from '@/services/user.service'

/** Rutas solo para business_admin; rol siempre desde API. */
export const BusinessAdminRouteGuard = async (to: any, from: any, next: any) => {
  const loggedIn = localStorage.getItem('access_token')
  if (!loggedIn) return next('/login')
  try {
    const user = await UserService.getUserData()
    if (!user || !UserService.isBusinessAdmin(user)) return next('/seller')
    next()
  } catch (error) {
    console.error('Error getting user data:', error)
    return next('/login')
  }
}

/**
 * Guard para panel de vendedores y rutas de listar/crear/editar vendedores.
 * Permite si el usuario es business_admin O is_boss (jefe de ventas).
 * Rol siempre desde API; no se confía en valores del cliente.
 */
export const AdminOrSalesBossRouteGuard = async (to: any, from: any, next: any) => {
  const loggedIn = localStorage.getItem('access_token')
  if (!loggedIn) return next('/login')

  try {
    const user = await UserService.getUserData()
    if (!user) return next('/login')

    if (UserService.isBusinessAdmin(user)) return next()
    await UserService.loadLocationsWhereBoss()
    if (UserService.isSalesBoss()) return next()
    return next('/seller')
  } catch (error) {
    console.error('Error in AdminOrSalesBossRouteGuard:', error)
    return next('/login')
  }
}
